import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  NumberInput,
  NumberInputField,
  Input
} from '@chakra-ui/react'
import { ChangeEvent, FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useOptimizerDefault from '@hook/optimizer/use-optimizer-default'

const OptimizerConfigDefaultCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    filterEdit,
    loadingEdit,
    selected,
    paramsEdit,
    handleUpdateEditParams,
    createData,
    // clearForm,
    updateDataCurve
  } = useOptimizerDefault()

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    handleUpdateEditParams({
      name: 'curva',
      value: value
    })
  }
  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
          mr={2}
          ml={2}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
          mr={2}
          ml={2}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0
                  ? 'Editar Parametro Default'
                  : 'Criar Novo Parametro'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton
          // onClick={clearForm}
          />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <FormLabel>(*) Curva</FormLabel>
              <Input
                borderBottomColor="black"
                value={paramsEdit.curva}
                onChange={handleInputChange}
              ></Input>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Minimo</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.min}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'min',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Maximo</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.max}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'max',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Default</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.default}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'default',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>

            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateDataCurve()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              isDisabled={paramsEdit.curva.length === 0}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default OptimizerConfigDefaultCreate
